import buyNowMixin from './buy-now';
import trial2paid from './trial2paid';
import Edit from './edit';
import { flowTypes, pageConfig } from '@/common/service/page-config';

export default {
  [flowTypes.buyNow]: buyNowMixin,
  [flowTypes.basic2pro]: buyNowMixin,
  [flowTypes.edit]: Edit,
  [flowTypes.add2cart]: buyNowMixin,
  [flowTypes.trial2paid]: trial2paid,
}[pageConfig.type];
